import React, { useContext, useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { tmsLogo } from "../../../assets/images/tms-image-list";
import { BaseContext } from "../../../contexts/BaseContext";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import { tmsSiderMap } from "../../../constants/tms-sider.map";
import "../../../assets/css/tms-layout/tms-layout.scss";
import checkPermissions from "../../../utils/tms-permissions/tms-permissions";
const TmsHomeSider = ({ router, toggleSider, templeDetails }) => {
  const [selectedNavItem, setSelectedNavItem] = useState(["/home"]);
  const [routeMapState, setRouteMapState] = useState();
  const [collapsedWidth, setCollapsedWidth] = useState(80);
  const { userDetails } = useContext(BaseContext);
  const [isHovered, setIsHovered] = useState(false); // Track hover state

  const { Sider } = Layout;
  const screens = useBreakpoint();

  useEffect(() => {
    // console.log(userDetails);
    if (screens?.xl || screens?.xxl || screens?.lg) {
      setCollapsedWidth(80);
    } else {
      setCollapsedWidth(0);
    }
  }, [screens]);

  const onMenuClick = (event) => {
    const { key } = event;
    if (collapsedWidth === 0) {
      toggleSider();
    }
    router?.navigate(key);
  };

  useEffect(() => {
    setRouteMapState(
      tmsSiderMap.map((item) => {
        return {
          label: item.name,
          key: item.route,
          icon: <img src={item.icon} alt="" />,
          children: item.children,
        };
      })
    );

    setSelectedNavItem(
      tmsSiderMap.find((_item) =>
        router?.location?.pathname?.startsWith(_item.route)
      )?.route
    );
  }, [router?.location?.pathname, userDetails]);

  return (
    <Sider
      className="tms-menu_sider"
      style={{ position: "relative" }}
      onCollapse={toggleSider}
      collapsed={!isHovered}
      collapsedWidth={collapsedWidth}
      defaultCollapsed={false}
      onMouseEnter={() => setIsHovered(true)} // Set hover state to true on mouse enter
      onMouseLeave={() => setIsHovered(false)} // Set hover state to false on mouse leave
    >
      <div
        className={
          isHovered ? "tms-sider-logo wh-full" : "tms-sider-logo wh-80"
        }
      >
        <img className="tms-sider-inner-logo" src={tmsLogo} alt="tms_logo" />
      </div>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={selectedNavItem}
        onClick={onMenuClick}
        items={routeMapState}
        style={{ textAlign: "left" }}
        inlineIndent={15}
      />
    </Sider>
  );
};

export default withRouter(TmsHomeSider);
